import { Button, Card, CardBody, CardFooter, CardHeader, Center, HStack, Heading, Text, Wrap, WrapItem } from "@chakra-ui/react";
import React, { useState } from "react";
import { ViewData } from "../data/ViewData";
import { EvmRoutes, RoutesData } from "../data/RoutesData";
import { useNavigate } from "react-router-dom";
import { ArbNovaIcon, BaseIcon, CkbIcon, EthIcon, GodwokenIcon, LineaIcon, OpBnbIcon, PgnIcon, PolygonIcon, ScrollIcon, StarkNetIcon, TaikoIcon, ZkSyncIcon, ZoraIcon } from "../icons/Icons";
import { ChainsInfo } from "../data/ChainsInfo";
import { EvmWorker } from "../client/EvmWorker";
import { ChainCardHeader, ChainNetworkBadge } from "./ChainNetworkBadge";

export const ChainsNavigator = () => {
    const [connected, setConnected] = useState(ViewData.wallet !== null);
    const [ethMinted, setEthMinted] = useState(ViewData.MintStatus.ethereum);
    const [arbNovaMinted, setArbNovaMinted] = useState(ViewData.MintStatus.arbNova);
    const [baseMinted, setBaseMinted] = useState(ViewData.MintStatus.base);
    const [godwokenMinted, setGodwokenMinted] = useState(ViewData.MintStatus.godwoken);
    const [lineaMinted, setLineaMinted] = useState(ViewData.MintStatus.linea);
    const [opBNBMinted, setOpBNBMinted] = useState(ViewData.MintStatus.opBnb);
    const [pgnMinted, setPGNMinted] = useState(ViewData.MintStatus.pgn);
    const [zkEvmMinted, setZkEvmMinted] = useState(ViewData.MintStatus.polygonZkEvm);
    const [scrollMinted, setScrollMinted] = useState(ViewData.MintStatus.scroll);
    const [taikoMinted, setTaikoMinted] = useState(ViewData.MintStatus.taiko);
    const [zkSyncMinted, setZkSyncMinted] = useState(ViewData.MintStatus.zksync);
    const [zoraMinted, setZoraMinted] = useState(ViewData.MintStatus.zora);
    const [nervosMinted, setNervosMinted] = useState(ViewData.MintStatus.nervos);
    const [starknetMinted, setStarknetMinted] = useState(ViewData.MintStatus.starknet);
    const nav = useNavigate();

    const navgateTo = async (chain: any) => {
        // switch chain
        await EvmWorker.requestNetwork(chain.chainInfo.requestParams);
        // navigate
        nav(chain.route);
    }
    
    if(ViewData.ethAddress && ViewData.ethAddress.length > 3)
    return (
        <Wrap spacing={4}>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Ethereum" icon={null} mainnetInfo={ChainsInfo.ethereum.mainnet} />
                    <CardBody>
                        <Center>
                            <EthIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={ethMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.ethereum)}>{ethMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Arbitrum Nova" icon={null} mainnetInfo={ChainsInfo.arbNova.mainnet} />
                    <CardBody>
                        <Center>
                            <ArbNovaIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={arbNovaMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.arbNova)}>{arbNovaMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Base" icon={null} mainnetInfo={ChainsInfo.base.mainnet} />
                    <CardBody>
                        <Center>
                            <BaseIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={baseMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.base)}>{baseMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Godwoken" icon={null} mainnetInfo={ChainsInfo.godwoken.mainnet} />
                    <CardBody>
                        <Center>
                            <GodwokenIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={godwokenMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.godwoken)}>{godwokenMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Linea" icon={null} mainnetInfo={ChainsInfo.linea.mainnet} />
                    <CardBody>
                        <Center>
                            <LineaIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={lineaMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.linea)}>{lineaMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="opBNB" icon={null} mainnetInfo={ChainsInfo.opBnb.mainnet} />
                    <CardBody>
                        <Center>
                            <OpBnbIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={opBNBMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.opBnb)}>{opBNBMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="PGN" icon={null} mainnetInfo={ChainsInfo.pgn.mainnet} />
                    <CardBody>
                        <Center>
                            <PgnIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={pgnMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.pgn)}>{pgnMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Polygon zkEVM" icon={null} mainnetInfo={ChainsInfo.polygonZkEvm.mainnet} />
                    <CardBody>
                        <Center>
                            <PolygonIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={zkEvmMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.polygonZkEvm)}>{zkEvmMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Scroll" icon={null} mainnetInfo={ChainsInfo.scroll.mainnet} />
                    <CardBody>
                        <Center>
                            <ScrollIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={scrollMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.scroll)}>{scrollMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Taiko" icon={null} mainnetInfo={ChainsInfo.taiko.mainnet} />
                    <CardBody>
                        <Center>
                            <TaikoIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={taikoMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.taiko)}>{taikoMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="zkSync" icon={null} mainnetInfo={ChainsInfo.zksync.mainnet} />
                    <CardBody>
                        <Center>
                            <ZkSyncIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={zkSyncMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.zksync)}>{zkSyncMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
            <WrapItem>
                <Card w="260px" h="320px">
                    <ChainCardHeader title="Zora" icon={null} mainnetInfo={ChainsInfo.zora.mainnet} />
                    <CardBody>
                        <Center>
                            <ZoraIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={zoraMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => navgateTo(EvmRoutes.zora)}>{zoraMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
        </Wrap>
    );
    else if(ViewData.pubKeyHex_Nervos && ViewData.pubKeyHex_Nervos.length > 60)
    return (
        <Wrap spacing={4}>
            <WrapItem>
                <Card w="260px" h="320px">
                    <CardHeader>
                        <Heading size='md'>
                            <HStack>
                                <Text>Nervos</Text>
                                <ChainNetworkBadge testnet={true} />
                            </HStack>
                        </Heading>
                    </CardHeader>
                    <CardBody>
                        <Center>
                            <CkbIcon w="96px" h="96px"/>
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={nervosMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => nav(RoutesData.Nervos)}>{nervosMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
        </Wrap>
    );
    else if(ViewData.starknetAddress && ViewData.starknetAddress.length > 60)
    return (
        <Wrap spacing={4}>
            <WrapItem>
                <Card w="260px" h="320px">
                    <CardHeader>
                        <Heading size='md'>
                            <HStack>
                                <Text>Starknet</Text>
                                <ChainNetworkBadge testnet={true} />
                            </HStack>
                        </Heading>
                    </CardHeader>
                    <CardBody>
                        <Center>
                            <StarkNetIcon w="96px" h="96px" />
                        </Center>
                    </CardBody>
                    <CardFooter>
                        <Button colorScheme={starknetMinted ? 'cyan' : 'green'} isDisabled={!connected}
                            onClick={e => nav(RoutesData.StarkNet)}>{starknetMinted ? 'View' : 'Mint'}</Button>
                    </CardFooter>
                </Card>
            </WrapItem>
        </Wrap>
    );
    else return (<></>);
}